import React from "react";
import SearchSelect from "Components/Fragment/SearchSelect";
import { decode } from "lib/format";
import withLanguageContext from "lib/hocs/withLanguageContext";

const SelectionDropDown = ({
  languageContext,
  selections,
  onChange,
  selection,
}) => {
  const active = {
    value: selection.type + "-" + selection.id,
    label: decode(selection.title),
  };

  const teamOptions = selections
    .filter((selection) => selection.type === "team")
    .map((selection) => {
      return {
        value: selection.type + "-" + selection.id,
        label: decode(selection.title),
        group: languageContext("teams"),
      };
    });

  const unitOptions = selections
    .filter((selection) => selection.type === "unit")
    .map((selection) => {
      return {
        value: selection.type + "-" + selection.id,
        label: selection.title,
        group: languageContext("units"),
      };
    });

  const options = [...unitOptions, ...teamOptions];

  return (
    <SearchSelect
      id="managerSelect"
      className="managerSelect"
      placeholder={`${languageContext("selectUnit")}/${languageContext(
        "team",
      )}`}
      value={active}
      options={options}
      groupBy={(option) => option.group}
      getOptionLabel={(option) => option.label}
      onChange={(event, option) => (option ? onChange(option) : null)}
    />
  );
};

export default withLanguageContext(SelectionDropDown, "TalentManagement");
